import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);
const ADMIN_ROLE = "Admin";

const MODULE_ALIASES = {
  Dashboard: "Dashboard",
  Leads: "Leads",
  Clients: "Clients",
  Projects: "Projects",
  Invoices: "Invoices",
  Expenses: "Expenses",
  Settings: "Settings",
  Reports: "Reports",
  Payments: "Invoices",
  Templates: "Settings",
};

const normalizeUser = (user) => {
  if (!user) return null;
  return {
    ...user,
    status: user.status || "Active",
    assigned_brand_ids: user.assigned_brand_ids || [],
    module_permissions: user.module_permissions || {},
  };
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("ah_user");
    return raw ? normalizeUser(JSON.parse(raw)) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("ah_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => {
        const normalized = normalizeUser(r.data);
        setUser(normalized);
        localStorage.setItem("ah_user", JSON.stringify(normalized));
      }).catch(() => {});
    }
  }, [user]);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("ah_token", r.data.token);
      const normalized = normalizeUser(r.data.user);
      localStorage.setItem("ah_user", JSON.stringify(normalized));
      setUser(normalized);
      return normalized;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("ah_token");
    localStorage.removeItem("ah_user");
    localStorage.removeItem("ah_brand");
    setUser(null);
    window.location.href = "/login";
  };

  const isAdmin = user?.role === ADMIN_ROLE;
  const isPartner = user?.role === "Business Development Partner";
  const hasModuleAccess = (moduleName) => {
    if (!user) return false;
    if (isAdmin) return true;
    const moduleKey = MODULE_ALIASES[moduleName] || moduleName;
    return Boolean(user.module_permissions?.[moduleKey]);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isPartner, hasModuleAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
